import store from '@/store';

const hasDatosRC = () =>
   Boolean(store.state.responsabilidadCivil?.datos?.id_responsabilidad_civil_poliza);

export default {
   path: '/multicotizador/rc/',
   name: 'rc',
   children: [
      {
         path: 'informacion',
         name: 'rc/informacion',
         component: () => import('@/modules/responsabilidad-civil/views/InformacionView.vue'),
         beforeEnter: (to, from, next) => {
            if (!store.state.poliza.poliza.id_poliza) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
      {
         path: 'documentos',
         name: 'rc/documentos',
         component: () => import('@/modules/responsabilidad-civil/views/DocumentosView.vue'),
         beforeEnter: (to, from, next) => {
            if (!store.state.poliza.poliza.id_poliza) { next('/menu'); return; }
            if (!hasDatosRC()) { next({ name: 'rc/informacion' }); return; }
            next();
         },
      },
      {
         path: 'resumen',
         name: 'rc/resumen',
         component: () => import('@/modules/responsabilidad-civil/views/ResumenView.vue'),
         beforeEnter: (to, from, next) => {
            if (!store.state.poliza.poliza.id_poliza) { next('/menu'); return; }
            if (!hasDatosRC()) { next({ name: 'rc/informacion' }); return; }
            next();
         },
      },
   ],
};
